<template>
  <div class="container">
    <div class="hello">
      <h1 class="title">2023-2024 SHOWS</h1>
      <hr />
      <div class="date-list-container">
        <div class="date-list">
          <div class="item" v-for="item in items" v-bind:key="item.lieu">
            <div class="date">
              <span>{{ item.day }}</span>
              <span>{{ item.month }}</span>
            </div>
            <div class="lieu">
              <span class="salle">{{ item.lieu }}</span>
              <div class="ville">
                <span>{{ item.ville }}</span>
                <span v-if="item.region">, {{ item.region }}</span>
              </div>
            </div>
            <div class="etat" v-if="item.etat">
              <span style="color:orangered;" v-html="item.etat"></span>
            </div>
            <div class="etat" v-else>
              <span>{{ item.tarif }}</span>
            </div>
          </div>
        </div>
        <img
          class="photo-band"
          src="../assets/images/band.jpg"
          alt="Void Shelter - Alternative rock"
        />
      </div>
      <div class="footer">
        <h2 class="date-list_footer">WANT US TO PLAY ON YOUR STAGE?</h2>
        <a href="mailto:voidshelter@gmail.com">booking@voidshelter.com</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Dates",
  data() {
    return {
      items: [
        {
          day: "12",
          month: "March",
          lieu: "Palais des Congrès du Futuroscope (private show)",
          ville: "Chasseneuil-du-Poitou (86)",
        },
        {
          day: "12",
          month: "May",
          lieu: "Bar'Ouf w/ Mü & Mr Melas",
          ville: "Cholet (49)",
        },
        {
          day: "27",
          month: "May",
          lieu: "Private festival",
          ville: "Bazoges-en-Pareds (85)",
        },
        {
          day: "21",
          month: "June",
          lieu: "Fleming's Irish Pub (Fête de la musique)",
          ville: "Nantes (44)",
        },
        {
          day: "23",
          month: "June",
          lieu: "Release Party @ Le Ferrailleur",
          ville: "Nantes (44)",
        },
        {
          day: "7",
          month: "July",
          lieu: "Festival L'Envol des Sons",
          ville: "Bégrolles en Mauges (44)",
        },
        {
          day: "25",
          month: "Nov",
          lieu: "Tremplin La Corde Raide",
          ville: "Pontchateau (44)",
        },
        {
          day: "16",
          month: "DEC",
          lieu: "Uzine w/ Outroduction & C4T C4T",
          ville: "Rennes (35)",
        },
        {
          day: "20",
          month: "JAN",
          lieu: "Salle Emeraude w/ Koudeta & Furieux Mais Sage",
          ville: "Bressuire (79)",
        },
      ],
    };
  },
};
</script>

<style scoped>
.date-list-container {
  display: flex;
  justify-content: space-evenly;
}
@media screen and (max-width: 1200px) {
  .date-list-container {
    flex-direction: column;
  }
}
.date-list-container > * {
  margin: 30px 0;
  max-width: 100%;
}
.photo-band {
  width: 400px;
  max-width: 100%;
}
.date-list {
  min-width: 50%;
}

.item {
  display: flex;
  font-weight: bold;
  align-items: center;
}
.salle {
  font-weight: normal;
}

.item > * {
  display: flex;
  flex-direction: column;
  text-align: left;
  margin: 10px 10px 0 0;
}

.date {
  min-width: 15%;
}

.container {
  background-color: #fff;
}
.hello {
  max-width: 1200px;
  margin: 0 auto;
  padding: 30px;
  color: black;
  position: relative;
}
</style>
